import { render } from "./NPathLayer.vue?vue&type=template&id=6fa522b0&scoped=true"
import script from "./NPathLayer.vue?vue&type=script&lang=js"
export * from "./NPathLayer.vue?vue&type=script&lang=js"

import "./NPathLayer.vue?vue&type=style&index=0&id=6fa522b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa522b0"]])

export default __exports__